// Nombre visible de un SKU del catálogo o de una línea de la venta. Puro, sin React.

/** Nombre cuando no hay marca, modelo, descripción ni SKU. */
export const UNNAMED_ITEM = 'Sin nombre';

/** Lo mínimo para nombrar un SKU; la venta sin teléfono trae el sku en `null`. */
export interface NameableItem {
    sku?: string | null;
    brand?: string | null;
    model?: string | null;
    /** Nombre visible con que se dio de alta el kit o el servicio. */
    description?: string | null;
}

/** Marca y modelo si existen; si no, la descripción; si no, el SKU; si no, «Sin nombre». */
export function itemDisplayName(item: NameableItem): string {
    const name = [item.brand, item.model]
        .map((part) => part?.trim() ?? '')
        .filter((part) => part !== '')
        .join(' ');
    if (name !== '') return name;
    const description = item.description?.trim() ?? '';
    if (description !== '') return description;
    const sku = item.sku?.trim() ?? '';
    return sku !== '' ? sku : UNNAMED_ITEM;
}

/** Igual, completando la descripción con la del catálogo cargado (la línea apartada no la trae). */
export function catalogDisplayName(
    item: NameableItem,
    descriptions: ReadonlyMap<string, string>,
): string {
    return itemDisplayName({
        ...item,
        description: item.description ?? (item.sku ? descriptions.get(item.sku) : undefined),
    });
}
